var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99976 4.27261C10.4116 4.27261 12.5625 5.62806 13.6125 7.77261C12.5625 9.91715 10.4116 11.2726 7.99976 11.2726C5.58794 11.2726 3.43703 9.91715 2.38703 7.77261C3.43703 5.62806 5.58794 4.27261 7.99976 4.27261ZM7.99976 2.99988C4.81794 2.99988 2.10066 4.97897 0.999756 7.77261C2.10066 10.5662 4.81794 12.5453 7.99976 12.5453C11.1816 12.5453 13.8988 10.5662 14.9998 7.77261C13.8988 4.97897 11.1816 2.99988 7.99976 2.99988ZM7.99976 6.1817C8.87794 6.1817 9.59066 6.89442 9.59066 7.77261C9.59066 8.65079 8.87794 9.36351 7.99976 9.36351C7.12157 9.36351 6.40885 8.65079 6.40885 7.77261C6.40885 6.89442 7.12157 6.1817 7.99976 6.1817ZM7.99976 4.90897C6.42157 4.90897 5.13612 6.19442 5.13612 7.77261C5.13612 9.35079 6.42157 10.6362 7.99976 10.6362C9.57794 10.6362 10.8634 9.35079 10.8634 7.77261C10.8634 6.19442 9.57794 4.90897 7.99976 4.90897Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewingIcon);
export default __webpack_public_path__ + "97120/static/media/ViewingIcon.52b03e63a58e9ef961206303b946a231.svg";
export { ForwardRef as ReactComponent };